/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useState, useEffect } from "react";
import { InfiniteStoryBase, WithPreview } from "@quintype/components";
import { BlankStory } from "../story-templates/blank";

import { VideoStory } from "../story-templates/video";
import { PhotoStory } from "../story-templates/photo";
import { LiveBlogStory } from "../story-templates/live-blog";
import { number, object, shape, array } from "prop-types";
import metypeConfig from "../../../../config/metype-config";
import get from "lodash/get";
import NextStoryStickey from "../molecules/nexr-story";

import { storyPageLoadItems } from "../utils/api";

function StoryPageBase({ index, story, mostPopular, params }) {
  // Can switch to a different template based story-template, or only show a spoiler if index > 0
  const getTemplate = () => {
    if (story["story-template"] === "live-blog") {
      return (
        <LiveBlogStory
          story={story}
          mostPopular={index === 0 ? mostPopular : mostPopular}
          metypeConfig={metypeConfig}
          cardId={get(params, ["cardId"])}
        />
      );
    } else if (story["story-template"] === "video") {
      return (
        <VideoStory story={story} mostPopular={index === 0 ? mostPopular : mostPopular} metypeConfig={metypeConfig} />
      );
    } else if (story["story-template"] === "photo") {
      return (
        <PhotoStory story={story} mostPopular={index === 0 ? mostPopular : mostPopular} metypeConfig={metypeConfig} />
      );
    } else {
      return (
        <BlankStory story={story} mostPopular={index === 0 ? mostPopular : mostPopular} metypeConfig={metypeConfig} />
      );
    }
  };

  return (
    <React.Fragment>
      {getTemplate()}
      <NextStoryStickey story={story} />
    </React.Fragment>
  );
}

StoryPageBase.propTypes = {
  index: number,
  story: object,
  mostPopular: array,
  params: object
};

export function StoryPage(props) {
  return (
    <div className="story-container">
      <InfiniteStoryBase
        {...props}
        render={StoryPageBase}
        loadItems={pageNumber => storyPageLoadItems(pageNumber, props.data.mostPopular)}
        onInitialItemFocus={item =>
          app.registerPageView({ pageType: "story-page", data: { story: item.story } }, `/${item.story.slug}`)
        }
        onItemFocus={item => console.log(`Story In View: ${item.story.headline}`)}
      />
    </div>
  );
}

StoryPage.propTypes = {
  data: shape({
    story: object
  })
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    mostPopular: Array(5).fill(story)
  })
);
